// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PArX","right":"Footer_right__1dofe","buttons":"Footer_buttons__IIAFa"};